/**
 * @file Contains customization for MuiOutlinedInput Component
 */

import { Components } from '@mui/material';

const MuiOutlinedInput: Components['MuiOutlinedInput'] = {
  styleOverrides: {
    input: {
      // Have to use !important due to global applied styles on input elements
      // Replace global after all new designs are applied
      border: 'none !important',
      padding: 'var(--spacing-medium)',
    },
  },
};

export default MuiOutlinedInput;
